import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDiagramDateRange,
  setDiagramFilter,
} from "../../../../redux/slice/diagram";
import { usePop, useHookForm } from "../../../hooks";

import { exportTableExcel } from "../../../../service/table2";
import {
  cleanEmpty,
  cleanEmptyArray,
  convertToCanvas,
} from "../../../../service/common";
import { com_downloadFileSingle } from "../../../../service/downloadFile";

import {
  FormCalendar,
  FormMultiSelect,
  FormDropdown,
} from "../../../formElement";

import { classNames } from "primereact/utils";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";

export default function ModuleBlockTitle({
  type,
  moduleTitle,
  isExport,
  isExportRawList,
  isFilter,
  options,
} = {}) {
  const [isDownload, setIsDownload] = useState(false);
  const downloadPendingRef = useRef(false);
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "tbFilter",
      title: (props) =>
        `${props.data.filterType === "date" ? "日期區間" : "資料"}篩選`,
      isOpen: false,
    },
  ]);

  const exportImg = () => {
    options.progressAction(true);

    convertToCanvas({ targetId: options.targetId }).then((result) => {
      com_downloadFileSingle({
        isBlob: true,
        fileName: moduleTitle,
        url: result.blob,
        finishAction: () => options.progressAction(false),
      });
    });
  };

  const isExportBusy =
    isDownload || options.callMainAPI?.exportPending === true;

  const exportExcel = async ({ type }) => {
    if (downloadPendingRef.current || isExportBusy) return;

    downloadPendingRef.current = true;
    setIsDownload(true);
    if (!options.callMainAPI) return;

    try {
      const result = await options.callMainAPI({ isExport: true });
      if (result?.Response !== 1) {
        downloadPendingRef.current = false;
        setIsDownload(false);
      }
    } catch (error) {
      downloadPendingRef.current = false;
      setIsDownload(false);
    }
  };

  useEffect(() => {
    if (
      (!options.callMainAPI && !options.tbData.format) ||
      (options.callMainAPI && !options.tbData.export) ||
      !isDownload
    )
      return;

    setTimeout(() => {
      exportTableExcel({
        exportType: type.indexOf("chart") !== -1 ? "list" : "table",
        moduleTitle,
        ...options,
      });
      downloadPendingRef.current = false;
      setIsDownload(false);
    }, 10);
  }, [options.tbData.export, isDownload]);

  return (
    <>
      <div className="flex align-items-center text-lg font-bold text-white bg-tb-title p-2">
        {moduleTitle}

        <span className="ml-auto"></span>

        {options.setting?.dateRangeColumns && (
          <>
            <span
              className="hover:text-white-alpha-60 cursor-pointer transition-colors transition-duration-200 transition-ease-in-out px-1 ml-2"
              onClick={() =>
                openPop({
                  type: "tbFilter",
                  data: {
                    filterType: "date",
                    columns: options.setting.dateRangeColumns,
                  },
                })
              }
            >
              <i className="pi pi-calendar tooltip-calendar"></i>
            </span>
            <Tooltip
              className="bg-dark"
              target=".tooltip-calendar"
              autoHide={false}
              hideDelay={100}
              position="bottom"
              mouseTrack
              mouseTrackTop={20}
            >
              日期
            </Tooltip>
          </>
        )}

        {isFilter && (options.setting?.filterColumns || []).length > 0 && (
          <>
            <span
              className="hover:text-white-alpha-60 cursor-pointer transition-colors transition-duration-200 transition-ease-in-out px-1 ml-2"
              onClick={() =>
                openPop({
                  type: "tbFilter",
                  data: {
                    filterType: "other",
                  },
                })
              }
            >
              <i className="pi pi-filter tooltip-filter"></i>
            </span>
            <Tooltip
              className="bg-dark"
              target=".tooltip-filter"
              autoHide={false}
              hideDelay={100}
              position="bottom"
              mouseTrack
              mouseTrackTop={20}
            >
              篩選
            </Tooltip>
          </>
        )}

        {isExport && (
          <>
            {type.indexOf("chart") !== -1 && (
              <>
                <span
                  className="hover:text-white-alpha-60 cursor-pointer transition-colors transition-duration-200 transition-ease-in-out px-1 ml-2"
                  onClick={() => exportImg()}
                >
                  <i className="pi pi-image tooltip-chart"></i>
                </span>
                <Tooltip
                  className="bg-dark"
                  target=".tooltip-chart"
                  autoHide={false}
                  hideDelay={100}
                  position="bottom"
                  mouseTrack
                  mouseTrackTop={20}
                >
                  圖檔
                </Tooltip>
              </>
            )}

            {/* || (type.indexOf("chart") !== -1 && isExportRawList) */}
            {type.indexOf("chart") === -1 && (
              <>
                <span
                  className={classNames(
                    "transition-colors transition-duration-200 transition-ease-in-out px-1 ml-2",
                    {
                      "hover:text-white-alpha-60 cursor-pointer":
                        !isExportBusy,
                      "text-white-alpha-40 cursor-wait": isExportBusy,
                    }
                  )}
                  onClick={() => exportExcel({ type })}
                  aria-disabled={isExportBusy}
                >
                  <i
                    className={classNames("tooltip-table", {
                      "pi pi-file-excel": !isExportBusy,
                      "pi pi-spin pi-spinner": isExportBusy,
                    })}
                  ></i>
                </span>
                <Tooltip
                  className="bg-dark"
                  target=".tooltip-table"
                  autoHide={false}
                  hideDelay={100}
                  position="bottom"
                  mouseTrack
                  mouseTrackTop={20}
                >
                  {isExportBusy
                    ? "資料匯出中"
                    : type.indexOf("chart") !== -1
                    ? "清單"
                    : "表格"}
                </Tooltip>
              </>
            )}
          </>
        )}
      </div>

      {renderDialog({
        className: "w-11 lg:w-6 md:w-8 sm:w-10",
        children: (
          <>
            {isPop.tbFilter?.isOpen && (
              <ModulePopTbFilter
                prePopOption={popOption}
                closePrePop={closePop}
                moduleData={options.setting}
              />
            )}
          </>
        ),
      })}
    </>
  );
}

function ModulePopTbFilter({ prePopOption, closePrePop, moduleData }) {
  const dispatch = useDispatch();
  const redux_diagram = useSelector((state) => state.diagram);
  const defaultValues = {
    isFrozen: true,
  };
  const { handleSubmit, getValues, reset, setting } = useHookForm({
    defaultValues,
  });
  const [tbFilter, setTbFilter] = useState({});
  // 特定篩選 Key 使用 filterMainKey；其餘使用 key
  const filterKey = moduleData.filterMainKey ?? moduleData.key;

  useEffect(() => {
    reset(
      prePopOption.data.filterType === "date"
        ? (redux_diagram.dateRangeSetting?.[filterKey] || []).reduce(
            (pre, cur) => ({
              ...pre,
              [`${cur.key}_start`]: cur.start,
              [`${cur.key}_end`]: cur.end,
            }),
            {}
          )
        : Object.entries(redux_diagram.filterSetting?.[filterKey] || {}).reduce(
            (pre, cur) => ({ ...pre, [cur[0]]: cur[1].value }),
            {}
          )
    );
  }, [redux_diagram]);

  const onSubmit = (submitData) => {
    if (prePopOption.data.filterType === "date") {
      let nowFilter = moduleData.dateRangeColumns.map((item) => ({
        key: item.key,
        start: submitData[`${item.key}_start`] ?? null,
        end: submitData[`${item.key}_end`] ?? null,
      }));
      let filterData = {
        ...redux_diagram.dateRangeSetting,
        [filterKey]: nowFilter,
      };
      dispatch(setDiagramDateRange(filterData));
    } else {
      let filterRaw = moduleData.filterColumns.reduce(
        (pre, cur) => ({ ...pre, [cur.key]: cur.type }),
        {}
      );

      submitData = cleanEmptyArray(cleanEmpty(submitData));

      let nowFilter = null;
      if (Object.keys(submitData).length !== 0) {
        nowFilter = Object.entries(submitData).reduce(
          (pre, cur) => ({
            ...pre,
            [cur[0]]: {
              type: filterRaw[cur[0]] ?? "",
              value:
                filterRaw[cur[0]] === "singleDropdown"
                  ? cur[1]
                  : cur[1].map((item) => (item.label ? item?.value : item)),
            },
          }),
          {}
        );
      }

      let filterData = {
        ...redux_diagram.filterSetting,
        [filterKey]: nowFilter,
      };
      dispatch(setDiagramFilter(filterData));
    }
    closePrePop({ type: "tbFilter" });
  };

  return (
    <>
      <div className="px-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          {prePopOption.data.filterType === "date" && (
            <>
              {prePopOption.data.columns.map((item, index) => (
                <div
                  key={item.key}
                  className={classNames("col-12", {
                    "mt-2": index !== 0,
                  })}
                >
                  <label className="font-bold">{item.label}</label>
                  <div className="flex align-items-center mt-1">
                    <FormCalendar
                      className="w-6 sm:w-4 lg:w-3"
                      setting={setting}
                      data={{
                        name: `${item.key}_start`,
                        maxDate: getValues(`${item.key}_end`),
                        placeholder: "起始日期",
                      }}
                    />
                    <span className="mx-2">-</span>
                    <FormCalendar
                      className="w-6 sm:w-4 lg:w-3"
                      setting={setting}
                      data={{
                        name: `${item.key}_end`,
                        minDate: getValues(`${item.key}_start`),
                        placeholder: "結束日期",
                      }}
                    />
                  </div>
                </div>
              ))}
            </>
          )}

          {prePopOption.data.filterType !== "date" && (
            <>
              {(moduleData.filterColumns || []).map((item) => (
                <div
                  key={`filter_${item.key}`}
                  className="flex flex-column col-6 sm:col-4 lg:col-3"
                >
                  <label className="font-bold mb-1">
                    {item.label || item.key}
                  </label>
                  {item.type === "singleDropdown" ? (
                    <FormDropdown
                      className="w-full"
                      setting={setting}
                      data={{
                        name: item.key,
                        options: item.options,
                        optionLabel: "label",
                        optionValue: "value",
                      }}
                    />
                  ) : (
                    <FormMultiSelect
                      className="w-full"
                      setting={setting}
                      data={{
                        name: item.key,
                        options: (moduleData.categoryData?.[item.key] || [])
                          .filter(
                            (category) =>
                              category !== null &&
                              category !== "" &&
                              category !== undefined
                          )
                          .sort(function (pre, next) {
                            return String(next).localeCompare(String(pre));
                          })
                          .map((category) => ({
                            label: category,
                            value: category,
                          })),
                      }}
                    />
                  )}
                </div>
              ))}
            </>
          )}

          <div className="col-12 text-right mt-3">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => closePrePop({ type: "tbFilter" })}
            />
            <Button type="submit" label="確認" className="ml-2 px-3" />
          </div>
        </form>
      </div>
    </>
  );
}
